import React from 'react';
import { FilterOption } from '../../../components/ui';
import {
  OnlyFansIc,
  InstagramIc,
  GoogleIc,
  TwitterIc,
  GlobalIc,
  IcReddit,
  IcAnotherSoc,
  IcTg,
  IcTikTok,
  IcYoutube,
} from '../../../components/icons';

// Функции для получения переводов с контекстом
export const getSortOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('orders.filters.sort.label') },
  { key: 'arpu', label: t('orders.filters.sort.arpu') },
  { key: '-arpu', label: t('orders.filters.sort.arpu') },
  { key: 'romi', label: t('orders.filters.sort.romi') },
  { key: '-romi', label: t('orders.filters.sort.romi') },
  { key: 'subscribed_count', label: t('orders.filters.sort.fans') },
  { key: '-subscribed_count', label: t('orders.filters.sort.fans') },
  { key: 'transactions_statistic.total', label: t('orders.filters.sort.totalRevenue') },
  { key: '-transactions_statistic.total', label: t('orders.filters.sort.totalRevenue') },
  { key: 'subs.with_gte_3_chat_messages_count', label: t('orders.filters.sort.messages') },
  { key: '-subs.with_gte_3_chat_messages_count', label: t('orders.filters.sort.messages') },
  { key: 'created_at', label: t('orders.filters.sort.orderDate') },
  { key: '-created_at', label: t('orders.filters.sort.orderDate') },
];

export const getOrderStatuses = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('orders.filters.status.label') },
  { key: 'in_progress', label: t('orders.filters.status.inProgress') },
  { key: 'pending', label: t('orders.filters.status.pending') },
  { key: 'completed', label: t('orders.filters.status.completed') },
  { key: 'canceled', label: t('orders.filters.status.cancelled') },
  { key: 'not_started', label: t('orders.filters.status.notStarted') },
];

export const getCampaignTypes = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('orders.filters.campaignType.label') },
  { key: 'free', label: t('orders.filters.campaignType.free') },
  { key: 'free trial', label: t('orders.filters.campaignType.freeTrial') },
];

export const getOrderSources = (t: (key: string) => string): FilterOption[] => [
  {
    key: 'all',
    label: t('orders.filters.sources.all'),
    icon: React.createElement(GlobalIc, { size: 16 }),
  },
  {
    key: 'only_fans',
    label: t('orders.filters.sources.onlyFans'),
    icon: React.createElement(OnlyFansIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'reddit',
    label: t('orders.filters.sources.reddit'),
    icon: React.createElement(IcReddit, { size: 16 }),
  },
  {
    key: 'instagram',
    label: t('orders.filters.sources.instagram'),
    icon: React.createElement(InstagramIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'tiktok',
    label: t('orders.filters.sources.tiktok'),
    icon: React.createElement(IcTikTok, { size: 16 }),
  },
  {
    key: 'google',
    label: t('orders.filters.sources.google'),
    icon: React.createElement(GoogleIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'telegram',
    label: t('orders.filters.sources.telegram'),
    icon: React.createElement(IcTg, { size: 16 }),
  },
  {
    key: 'twitter',
    label: t('orders.filters.sources.twitter'),
    icon: React.createElement(TwitterIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'youtube',
    label: t('orders.filters.sources.youtube'),
    icon: React.createElement(IcYoutube, { size: 16 }),
  },
  {
    key: 'another',
    label: t('orders.filters.sources.other'),
    icon: React.createElement(IcAnotherSoc, { size: 16 }),
  },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: t('orders.table.columns.id'), key: 'id' },
  { name: t('orders.table.columns.account'), key: 'account' },
  { name: t('orders.table.columns.offer'), key: 'offer' },
  { name: t('orders.table.columns.campaign'), key: 'campaign' },
  { name: t('orders.table.columns.status'), key: 'status' },
  { name: t('orders.table.columns.startDate'), key: 'startDate' },
];

export const getStatusLabels = (t: (key: string) => string) => ({
  completed: t('orders.status.completed'),
  processing: t('orders.status.processing'),
  pending: t('orders.status.pending'),
  canceled: t('orders.status.cancelled'),
  refunded: t('orders.status.refunded'),
  in_progress: t('orders.status.inProgress'),
  not_started: t('orders.status.notStarted'),
});

// Статические константы (остаются как есть)
export const SORT_OPTIONS: FilterOption[] = [
  { key: 'all', label: 'Сортировка' },
  { key: 'arpu', label: 'ARPU' },
  { key: '-arpu', label: 'ARPU' },
  { key: 'romi', label: 'ROMI' },
  { key: '-romi', label: 'ROMI' },
  { key: 'subscribed_count', label: 'Фанатов' },
  { key: '-subscribed_count', label: 'Фанатов' },
  { key: 'transactions_statistic.total', label: 'Общий доход' },
  { key: '-transactions_statistic.total', label: 'Общий доход' },
  { key: 'subs.with_gte_3_chat_messages_count', label: 'Сообщения' },
  { key: '-subs.with_gte_3_chat_messages_count', label: 'Сообщения' },
  { key: 'created_at', label: 'Дата заказа' },
  { key: '-created_at', label: 'Дата заказа' },
];

export const ORDER_STATUSES: FilterOption[] = [
  { key: 'all', label: 'Статус' },
  { key: 'in_progress', label: 'В работе' },
  { key: 'pending', label: 'В ожидании' },
  { key: 'completed', label: 'Завершён' },
  { key: 'canceled', label: 'Деактивирован' },
  { key: 'not_started', label: 'Не начат' },
];

export const CAMPAIGN_TYPES: FilterOption[] = [
  { key: 'all', label: 'Тип кампании' },
  { key: 'free', label: 'FREE' },
  { key: 'free trial', label: 'Free-trial' },
];

export const ORDER_SOURCES: FilterOption[] = [
  { key: 'all', label: 'Все источники', icon: React.createElement(GlobalIc, { size: 16 }) },
  {
    key: 'only_fans',
    label: 'OnlyFans',
    icon: React.createElement(OnlyFansIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'reddit', label: 'Reddit', icon: React.createElement(IcReddit, { size: 16 }) },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: React.createElement(InstagramIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'tiktok', label: 'TikTok', icon: React.createElement(IcTikTok, { size: 16 }) },
  {
    key: 'google',
    label: 'Google',
    icon: React.createElement(GoogleIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'telegram', label: 'Telegram', icon: React.createElement(IcTg, { size: 16 }) },
  {
    key: 'twitter',
    label: 'Twitter',
    icon: React.createElement(TwitterIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'youtube', label: 'YouTube', icon: React.createElement(IcYoutube, { size: 16 }) },
  { key: 'another', label: 'Другие', icon: React.createElement(IcAnotherSoc, { size: 16 }) },
];

export const TABLE_COLUMNS = [
  { name: 'ID', key: 'id' },
  { name: 'Аккаунт', key: 'account' },
  { name: 'Оффер', key: 'offer' },
  { name: 'Кампания', key: 'campaign' },
  { name: 'Статус', key: 'status' },
  { name: 'Старт кампании', key: 'startDate' },
];

export const STATUS_LABELS = {
  completed: 'Завершён',
  processing: 'Обработка',
  pending: 'В ожидании',
  cancelled: 'Деактивирован',
  refunded: 'Возврат',
  in_progress: 'В работе',
  not_started: 'Не начат',
} as const;

export const DEFAULT_FILTERS = {
  search: '',
  sort: 'all',
  models: [],
  campaignType: 'all',
  status: 'all',
  source: 'all',
  subs_form: null,
  income: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const MODELS_PAGE_SIZE = 30;
export const SEARCH_DEBOUNCE_DELAY = 500;
export const MODEL_SEARCH_DEBOUNCE_DELAY = 300;
